import * as React from "react"

const Footer = () => {
  return (
    <footer>
      © 2021 - <a href="https://satokes.uk">satokes.uk</a>
    </footer>
  )
}

export default Footer
